import { createAction } from '@reduxjs/toolkit';

export const requestCreateSupportTemplate = createAction('request/createSupportTemplate');
export const requestViewSupportTemplate = createAction('request/ViewSupportTemplate');
export const requestUpdateSupportTemplate = createAction('request/UpdateSupportTemplate');
